import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Location } from '@grandvisionhq/api-client';
import { useFeatureToggles } from '@grandvisionhq/state';
import '@grandvisionhq/utils';
import '../types/index.js';
import { getCoordinatesMultiCountry } from '../utils/get-coordinates-multi-country.js';

const withGetCoordinates = (Component)=>{
    const wrappedName = Component.displayName || Component.name || 'Component';
    const WithGetCoordinates = (props)=>{
        const { isMultiCountryLocationsEnabled  } = useFeatureToggles();
        const getCoordinates = isMultiCountryLocationsEnabled ? getCoordinatesMultiCountry : Location.getCoordinates;
        return /*#__PURE__*/ React.createElement(Component, swcHelpers.extends({}, props, {
            getCoordinates: getCoordinates
        }));
    };
    WithGetCoordinates.displayName = `WithGetCoordinates(${wrappedName})`;
    return WithGetCoordinates;
};

export { withGetCoordinates };
//# sourceMappingURL=with-get-coordinates.js.map
